export const saveChatConfig = async (config) => {
  try {
    const response = await fetch(
      "https://pfx1jlc6k6.execute-api.eu-west-3.amazonaws.com/prod/save-chat-config",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(config),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error saving chat config:", error);
    return "ERROR";
  }
};

export const loadChatConfig = async (id) => {
  if (!id) return;
  try {
    const response = await fetch(
      `https://pfx1jlc6k6.execute-api.eu-west-3.amazonaws.com/prod/load-chat-config?id=${id}`,
      {
        method: "GET",
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error loading chat config:", error);
  }
};

export const deleteChatConfig = async (id) => {
  try {
    const response = await fetch(
      "https://pfx1jlc6k6.execute-api.eu-west-3.amazonaws.com/prod/delete-chat-config",
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting chat config:", error);
  }
};
